import { IBaseAction, PaginationQuery } from "../../constants";

/*export interface ObjectId {
  date: Date
  timestamp: number
}
*/

export type ObjectId = string

export interface Identity {
    id: ObjectId;
    name: string;
    firstName?: string;
    lastName?: string;
    username: string;
    description: string;
}




export interface User extends Identity {
    password: string;
    email: string;
}

export class UserGroup extends PaginationQuery {
    users: Array<User> = [];
    id: string = '';
    name: string = '';
    username: string = ''
    description: string = '';
    constructor() { super() }
    //policies: Array<Policy>
}
export const userGroupInit = new UserGroup()

export type GroupsWithUserState = Array<UserGroup>;
export interface GroupsWithUserPaginationState {
    data: GroupsWithUserState
    total: number;
}
export const GET_GROUPS_WITH_USER = 'GET_GROUPS_WITH_USER';
export const GET_GROUPS_WITH_USER_SUCCESS = 'GET_GROUPS_WITH_USER_SUCCESS';
export const GET_GROUPS_WITH_USER_FAILURE = 'GET_GROUPS_WITH_USER_FAILURE';
export const GET_GROUPS_WITH_USER_CLEAR = 'GET_GROUPS_WITH_USER_CLEAR';

export const GET_GROUPS = 'GET_GROUPS';
export const GET_GROUPS_SUCCESS = 'GET_GROUPS_SUCCESS';

interface GetGroupsWithUsersAction extends IBaseAction {
    type: typeof GET_USER_GROUPS | typeof GET_GROUPS_WITH_USER_SUCCESS | typeof GET_GROUPS | typeof GET_GROUPS_SUCCESS | typeof GET_GROUPS_WITH_USER_CLEAR
    payload: {
        data: GroupsWithUserPaginationState
    },
}





export const userInit: User = {
    /*id: {
      date: new Date(),
      timestamp: Date.now()
    },*/
    id: '',
    email: '',
    name: '',
    firstName: '',
    lastName: '',
    password: '',
    description: '',
    username: '',
    //groups: [],
    //policies: []

}

export class GetUsersWithGroupsQuery extends PaginationQuery {
    constructor() {
        super();
    }
}


export const GET_USERS_WITH_GROUPS = 'GET_USERS_WITH_GROUPS';
export const GET_USERS_WITH_GROUPS_SUCCESS = 'GET_USERS_WITH_GROUPS_SUCCESS';
export const GET_USERS_WITH_GROUPS_FAILURE = 'GET_USERS_WITH_GROUPS_FAILURE';
export const GET_USERS = 'GET_USERS';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USERS_OPTIONS = 'GET_USERS_OPTIONS';
export const GET_USERS_OPTIONS_SUCCESS = 'GET_USERS_OPTIONS_SUCCESS';
export const INSERT_USER = 'INSERT_USER';
export const INSERT_USER_SUCCESS = 'INSERT_USER_SUCCESS';
export const INSERT_USER_FAILURE = 'INSERT_USER_FAILURE';
export const DELETE_USER = 'DELETE_USER';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAILURE = 'DELETE_USER_FAILURE';

export type UserWithGroupsState = Array<User>;
export type UsersState = Array<User>;

export interface UsersPaginationState {
    data: UsersState
    total: number;
}

interface GetUserWithGroupsAction extends IBaseAction {
    type:
    typeof GET_USERS_WITH_GROUPS |
    typeof GET_USERS_WITH_GROUPS_SUCCESS |
    typeof GET_USERS_SUCCESS |
    typeof GET_USERS |
    typeof GET_USERS_OPTIONS_SUCCESS |
    typeof GET_USERS_OPTIONS |
    typeof DELETE_USER |
    typeof DELETE_USER_SUCCESS

    payload: {
        data: UserWithGroupsState | UsersPaginationState
    },
}

export type UserGroupState = { [key in string]: GroupsWithUserState };
export const GET_USER_GROUPS = 'GET_USER_GROUPS';

export const INSERT_OR_UPDATE_USER_GROUPS = 'INSERT_OR_UPDATE_USER_GROUPS';
export const INSERT_OR_UPDATE_USER_GROUPS_SUCCESS = 'INSERT_OR_UPDATE_USER_GROUPS_SUCCESS';
export const INSERT_OR_UPDATE_USER_GROUPS_FAILURE = 'INSERT_OR_UPDATE_USER_GROUPS_FAILURE';
export const DELETE_USER_GROUPS = 'DELETE_USER_GROUPS';
export const DELETE_USER_GROUPS_SUCCESS = 'DELETE_USER_GROUPS_SUCCESS';
export const DELETE_USER_GROUPS_FAILURE = 'DELETE_USER_GROUPS_FAILURE';


export interface IamPolicyStatement {
    actions: Array<string>
    effect: string
    resource: string
    conditions: any

}

export interface IamPolicyIdentities {
    users: Array<Identity>
    groups: Array<Identity>
    roles: Array<Identity>
}
export const iamPolicyIdentitiesInit: IamPolicyIdentities = {
    users: [],
    groups: [],
    roles: [],
}

export class Policy extends PaginationQuery {
    id: string = '';
    name: string = '';
    description: string = '';
    statements: Array<IamPolicyStatement> = [];
    identities: IamPolicyIdentities = iamPolicyIdentitiesInit;
    constructor() { super() }
}


export const initPolicy = new Policy()

export type PoliciesState = Array<Policy>;
export interface PoliciesPaginationState {
    data: PoliciesState
    total: number;
}

export const GET_POLICIES = 'GET_POLICIES';
export const GET_POLICIES_SUCCESS = 'GET_POLICIES_SUCCESS';
export const GET_FULL_POLICIES = 'GET_FULL_POLICIES';
export const GET_FULL_POLICIES_SUCCESS = 'GET_FULL_POLICIES_SUCCESS';
export const GET_FULL_POLICIES_CLEAR = 'GET_FULL_POLICIES_CLEAR';
export const INSERT_OR_UPDATE_POLICY = 'INSERT_OR_UPDATE_POLICY';
export const INSERT_OR_UPDATE_POLICY_SUCCESS = 'INSERT_OR_UPDATE_POLICY_SUCCESS';
export const INSERT_OR_UPDATE_POLICY_FAILURE = 'INSERT_OR_UPDATE_POLICY_FAILURE';
export const DELETE_POLICY = 'DELETE_POLICY';
export const DELETE_POLICY_SUCCESS = 'DELETE_POLICY_SUCCESS';

interface GetPoliciesAction extends IBaseAction {
    type: typeof GET_POLICIES | typeof GET_POLICIES_SUCCESS | typeof GET_FULL_POLICIES | typeof GET_FULL_POLICIES_SUCCESS | typeof GET_FULL_POLICIES_CLEAR
    payload: {
        data: PoliciesState | PoliciesPaginationState
    },
}


export type GroupPolicies = { [key in string]: PoliciesState };
export type UserPolicies = { [key in string]: PoliciesState };
//export const GET_GROUP_POLICIES = 'GET_GROUP_POLICIES';

export const RESET_MFA = 'RESET_MFA';
export const RESET_MFA_SUCCESS = 'RESET_MFA_SUCCESS';
export const RESET_MFA_FAILURE = 'RESET_MFA_FAILURE';


export type IamActionTypes =
    GetPoliciesAction |
    GetUserWithGroupsAction |
    GetGroupsWithUsersAction 